<template>
    <div class="m-sponsor body-item">
        <div class="title"></div>

        <div class="sponsor-view">
            <div class="container">
                <div class="swiper">
                    <swiper ref="sponsorSwiper" :options="swiperOptions">
                    <swiper-slide
                        v-for="(item,index) in list"
                        :key="index">

                        <div class="sponsor">
                            <a v-bind:href="item.url" target="_blank" rel="noopener noreferrer" v-bind:alt="item.name"></a>
                            <div class="img"><img v-bind:src="item.logo" srcset=""></div>
                        </div>

                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                </div>                
            </div>
        </div>
    </div>
</template>

<style scoped>

    .m-sponsor{
        margin-top: 155px;
    }

    .title{
        width: 1113px;
        height: 170px;
        margin: 0 auto;
        background-image: url(~@/assets/images/title-6.png);
    }

    .sponsor-view{
        width: 1387px;
        height: 241px;
        margin: 45px auto 0;
        background-image: url(~@/assets/images/bg-corp-view.png);        
    }

    .sponsor-view .container{
        display: flex;
        height: 100%;
        padding: 0 15px;
        justify-content: space-between;
        align-items: center;
    }

    .sponsor{
        position: relative;
        display: flex;
        width: 260px;
        height: 127px;
        background-image: url(~@/assets/images/item-corp.png);
        justify-content: center;
        align-items: center;  
    }

    .sponsor a{
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
    }

    .sponsor .img,
    .sponsor img{
        width: 100%;
        height: 100%;        
    }
    
</style>

<style>
    .swiper{
        width: 100%;
    }
</style>

<script>
export default {
    data (){
        return {
            list : [],
            swiperOptions: {
                notNextTick: true,
                autoplay: {
                    disableOnInteraction: false,
                    delay:2000
                },
                slidesPerView: 5,
                spaceBetween: 17,
            }            
        }
    },
    created (){
        this.render();
    },
    methods : {
        render (){
            this.$axios.get(this.$ajax_url_map.partner)
            .then(res => {
                if(res.data.code == this.$ajax_code.success){
                    this.list = res.data.data
                }
                else{
                    this.$message.error('赞助商模块：数据请求失败，请稍后再试');
                }
            });
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/sponsor.vue